module.exports = __webpack_public_path__ + "static/img/esim1 (1).3437fd46.jpg";